// Tree shaking for only Geography class
export { Geography } from '@rbilabs/intl-common/dist/utils/geography';
